import { render, staticRenderFns } from "./MobOverviewIndex.vue?vue&type=template&id=057f5f66&scoped=true"
import script from "./MobOverviewIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./MobOverviewIndex.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "057f5f66",
  null
  
)

export default component.exports